import styled from "styled-components";
import { baseURL } from "../services/authentication.js"



const Container=styled.a`
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
height:13vh;
width: 200px;
text-decoration: none;
:visited{text-decoration: none};
transition:500ms;
color:black;
&:hover{
	scale:1.1
`
const ExcelDownload=styled.img`
height:75px;
}
`;

const Texto=styled.div`
font-family: 'Poppins', sans-serif;
text-align:center;
width:80%;
font-size:14px;
background-color:white;
border-radius:25px;

 `;


 export default function Flotante(props){return(

			<Container  href={`${baseURL}/archives/${props.archivo}`}>
				<ExcelDownload src={props.rutaIco} />
				<Texto><b>{props.texto}</b></Texto>
			</Container>



 	)}